import React, { useEffect, useState } from 'react';
import styles from './Prefecture.module.css';
import { FormTitle } from '../../../Common/FormTitle';
import { NextButton } from '../../../Common/CtaButton/NextButton';
import { FormField } from '../../../Common/FormField';
import { fetchCities } from '../../../../app/api/cityApi';
import { validateZipCode } from './validate';
import { LeadText } from '../../../Common/LeadText';

export const Prefecture = () => {
    const [zipCode, setZipCode] = useState('');
    const [address, setAddress] = useState('');
    const [cityId, setCityId] = useState<number | ''>('');
    const [cityName, setCityName] = useState('');
    const [prefectureId, setPrefectureId] = useState();
    const [error, setError] = useState('');
    const [isFormValid, setIsFormValid] = useState(false);

    useEffect(() => {
        const validateAddress = async () => {
            const result = await validateZipCode(zipCode);

            setError(result.error);
            setIsFormValid(result.isValid);

            if (result.isValid && result.data) {
                setPrefectureId(result.data.prefectureId);
                setCityName(result.data.cityName);
                setAddress(result.data.address);
            } else {
                setAddress('');
            }
        };
        validateAddress();
    }, [zipCode]);

    useEffect(() => {
        if (!prefectureId) {
            setCityId('');
            return;
        }

        const getCities = async () => {
            const result = await fetchCities(prefectureId);
            if (result.success) {
                const matchedCity = result.data.find(c => c.name === cityName);
                if (matchedCity) {
                    setCityId(matchedCity.id);
                }
            }
        };

        getCities();
    }, [prefectureId, cityName]);

    return (
        <div className={styles.wrapper}>
            <div className={styles.selectionWrapper}>
                <div className={styles.monthbox}>
                    <FormTitle
                        formTitleText="今はどこに住んでいますか？"
                        dataViewLabel="EF_住所_pv"
                        dataClickLabel="EF_住所_戻る"
                    />
                </div>
                <div className={styles.field}>
                    <FormField
                        label="郵便番号"
                        placeholder="1234567"
                        value={zipCode}
                        isInputType="number"
                        onChange={setZipCode}
                    />
                    <LeadText text="ハイフン「-」の入力は不要です" />
                </div>
                {isFormValid ? (
                    <div className={styles.addressResult}>
                        <img
                            src={'/foodslaboEf/img/step5/addressPin.svg'}
                            alt={'住所ピン'}
                        />
                        <p>{address}</p>
                    </div>
                ) : (
                    <p style={{ color: 'red' }}>{error}</p>
                )}
                <NextButton
                    formKey={['prefecture', 'city']}
                    formValue={[prefectureId, cityId]}
                    displayFormKey={'prefectureCity'}
                    displayFormValue={address}
                    isDisabled={!isFormValid}
                    dataClickLabel="EF_住所_次へ"
                />
            </div>
        </div>
    );
};
